<template>
  <div class="pogs-list--panels" :class="computedClass">
    <div class="pogs-list__item"
         v-for="item in charts"
         :key="item.id">
      <header>
        <strong>{{item.title}}</strong>
      </header>

      <template v-if="item.chart && item.data">
        <pogs-chart class="content"
                    :type="item.chart"
                    :dataPoints="item.data"
                    :size="item.size"/>
      </template>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'
  import PogsChart from '../charts/pogs-chart'
  //import MockReports from '../mockReportsSummary'
  import {
    GETTER_MORTALITY_RATE,
    GETTER_MORTALITY_AOG,
    GETTER_MORTALITY_DIRECT,
    GETTER_MORTALITY_TIMING,
    GETTER_PREGNANCY_TYPE,
    GETTER_DELIVERY_MANNER,
    GETTER_INDICATIONS_FOR_CS,
    GETTER_AOG,

    ACTION_LOAD_MORTALITY_RATE,
    ACTION_LOAD_MORTALITY_AOG,
    ACTION_LOAD_MORTALITY_DIRECT,
    ACTION_LOAD_MORTALITY_TIMING,
    ACTION_LOAD_ALL_PREGNANCY_TYPE,
    ACTION_LOAD_DELIVERY_MANNER,
    ACTION_LOAD_INDICATIONS_FOR_CS,
    ACTION_LOAD_AOG
  } from '../../../../store/modules/analytics-morbidity'

  export default {
    name: "pogs-reports__summary",
    components: {PogsChart},
    props: {
      dateFilter: {type:Object, default: () => ({
        from : new Date().setMonth(new Date().getMonth() - 3),
          to : new Date()
        }) }
    },
    data() {
      return {reporttype : "maternalMortality"}
    },
    computed: {
      ...mapGetters({
        // Mortality rates
        rate:GETTER_MORTALITY_RATE,
        aog:GETTER_MORTALITY_AOG,
        direct:GETTER_MORTALITY_DIRECT,
        timing:GETTER_MORTALITY_TIMING,
        pregnancyType: GETTER_PREGNANCY_TYPE,
        // OB Cases
        mannerOfDelivery : GETTER_DELIVERY_MANNER,
        csIndications    : GETTER_INDICATIONS_FOR_CS,
        aogAll           : GETTER_AOG
        
      }),
      charts(){
        if (this.reporttype === 'maternalMortality') {
          return [this.rate, this.aog, this.direct, this.timing]
        } else {
          return [this.mannerOfDelivery, this.aogAll, this.pregnancyType, this.csIndications]
        }
      },
      computedClass(){
        return this.reporttype == "maternalMortality" ? 'maternal-reports' : 'ob-reports';
      }
    },
    methods: {
      ...mapActions({
        getRate : ACTION_LOAD_MORTALITY_RATE,
        getAOG : ACTION_LOAD_MORTALITY_AOG,
        getDirect : ACTION_LOAD_MORTALITY_DIRECT,
        getTimingOfDeath : ACTION_LOAD_MORTALITY_TIMING,

        getPregnancyType : ACTION_LOAD_ALL_PREGNANCY_TYPE,
        getMannerOfDelivery : ACTION_LOAD_DELIVERY_MANNER,
        getCsIndications    : ACTION_LOAD_INDICATIONS_FOR_CS,
        getAOGAll : ACTION_LOAD_AOG

      }),
      // assume from and to are unixtimestamps
      init(reporttype , from, to) {
        if (reporttype === 'maternalMortality') {
          this.getRate({from, to});
          this.getAOG({from, to});
          this.getDirect({from, to});
          this.getTimingOfDeath({from, to});
        } else {
          this.getPregnancyType({from,to});
          this.getMannerOfDelivery({from,to});
          this.getCsIndications({from,to});
          this.getAOGAll({from, to});
        }
      }
    },
    watch: {
      dateFilter(newValue) {
        this.init(this.reporttype, newValue.from.getTime(), newValue.to.getTime());
      },
      deep:true
    },
    beforeRouteEnter(to,from,next) {
      let type = to.params.filterBy;
      //let fromDate = to.params.filterDateFrom ? to.params.filterDateFrom : new Date().setMonth(new Date().getMonth() - 3);
      //let toDate   = to.params.filterDateTo ? to.params.filterDateTo : new Date();
      next(vm => { vm.reporttype = type; vm.init(vm.reporttype, vm.dateFilter.from.getTime(), vm.dateFilter.to.getTime()); });
    },
    beforeRouteUpdate(to,from, next) {
      let type = to.params.filterBy;
      //let fromDate = to.params.filterDateFrom ? to.params.filterDateFrom : new Date().setMonth(new Date().getMonth() - 3);
      //let toDate   = to.params.filterDateTo ? to.params.filterDateTo : new Date();
      this.reporttype = type;
      this.init(this.reporttype, this.dateFilter.from.getTime(), this.dateFilter.to.getTime());
      //this.dateFilter = {from:fromDate, to: toDate}
      next();
    }
  }
</script>

<style lang="scss">
  @import '../../../../scaffolding/scss/pogs-util';

  .maternal-reports,
  .ob-reports{
    @include make-grid-cols(repeat(3,1fr), space(base), $stack-mobile: true);

    & > .pogs-list__item{
      min-height: 230px;
    }
  }

  .ob-reports{
    & > .pogs-list__item{
      &:last-child{
        grid-column: 1 / span 3;
      }
    }
  }
</style>